import { Box, Card, FormControl, Grid, Paper, TextField, Typography } from "@material-ui/core";
import Fab from "@material-ui/core/Fab";
import IconButton from "@material-ui/core/IconButton";
import { AddPhotoAlternateOutlined } from "@material-ui/icons";
import AttachmentIcon from "@material-ui/icons/Attachment";
import IconDelete from "@material-ui/icons/Delete";
import IconReplay from "@material-ui/icons/Replay";
import React from "react";

import { API_URL_STATIC } from "../../../../../config/config";
import IDocument from "../../../../../types/IDocument";
import IProjectGalleryImage from "../../../../../types/IProjectGalleryImage";
import { formatBytes } from "../../../../../utils/bytesConverter";

type IProps = {
    image: IProjectGalleryImage;
    index: number;
    isNotImage?: boolean;
    isSorting?: boolean;
    type: string;
    onChange: (type: string, image: IProjectGalleryImage, index: number) => void;
    onDelete: (type: string, index: number) => void;
    onReset: (type: string, index: number, imageId: number) => void;
};
const ImageGalleryCard = (props: IProps) => {
    const { image, index, isNotImage, isSorting, type, onChange, onDelete, onReset } = props;

    if (image === null) {
        return <div>Invalid image</div>;
    }

    const handleUploadClick = (event: any) => {
        const file = event.target.files[0];
        const reader = new FileReader();
        reader.readAsDataURL(file);

        reader.onloadend = () => {
            onChange(
                type,
                {
                    ...image,
                    document: {
                        ...image.document,
                        data: reader.result,
                        name: file.name,
                        size: file.size,
                        type: file.type,
                    },
                    isChanged: true,
                },
                props.index
            );
        };
    };

    const handleTextChange = (event: any) => {
        onChange(
            type,
            {
                ...image,
                document: {
                    ...image.document,
                    [event.target.name]: event.target.value,
                },
                isChanged: true,
            },
            props.index
        );
    };

    const getImageSrc = (imageNode: IDocument) => {
        if (imageNode.data) {
            return imageNode.data;
        }
        if (imageNode.url) {
            return API_URL_STATIC + imageNode.url;
        }

        return null;
    };

    const sizeIsNotNull = (size?: number | null) => {
        if (size == null) {
            return false;
        }

        return size > 0;
    };

    const imageSource = getImageSrc(image.document);
    return (
        <Grid container item xs={12} md={6} lg={4} direction="column">
            <Card variant="outlined" style={{ height: "100%" }}>
                <FormControl fullWidth>
                    <Paper elevation={0}>
                        {!isNotImage && (
                            <>
                                <input
                                    accept="image/*"
                                    id={"project-gallery-image-upload-" + props.index}
                                    type="file"
                                    style={{ display: "none" }}
                                    onChange={handleUploadClick}
                                />

                                <label htmlFor={"project-gallery-image-upload-" + props.index}>
                                    {!imageSource && (
                                        <Fab
                                            component="span"
                                            style={{
                                                marginTop: "16px",
                                                marginLeft: "16px",
                                                marginBottom: "16px",
                                            }}
                                        >
                                            <AddPhotoAlternateOutlined />
                                        </Fab>
                                    )}
                                </label>
                                {imageSource && (
                                    <img style={{ maxWidth: "100%" }} src={imageSource} alt={"fresh uploaded"} />
                                )}
                                {sizeIsNotNull(image.document.size) && (
                                    <Typography align="right">
                                        Dateigröße : {formatBytes(image.document.size)}
                                    </Typography>
                                )}
                            </>
                        )}
                        {isNotImage && (
                            <>
                                <input
                                    accept=".xlsx,.xls,.doc, .docx,.ppt, .pptx,.txt,.pdf"
                                    id={"project-gallery-attachements-upload-" + props.index}
                                    type="file"
                                    style={{ display: "none" }}
                                    onChange={handleUploadClick}
                                />

                                <label htmlFor={"project-gallery-attachements-upload-" + props.index}>
                                    {!imageSource && (
                                        <Fab
                                            component="span"
                                            style={{
                                                marginTop: "16px",
                                                marginLeft: "16px",
                                                marginBottom: "16px",
                                            }}
                                        >
                                            <AttachmentIcon />{" "}
                                        </Fab>
                                    )}
                                </label>
                                {imageSource && (
                                    <>
                                        <Typography align="center" component="div">
                                            {image.document.name}
                                        </Typography>

                                        {sizeIsNotNull(image.document.size) && (
                                            <Typography align="center">
                                                Dateigröße : {formatBytes(image.document.size)}
                                            </Typography>
                                        )}
                                    </>
                                )}
                            </>
                        )}
                    </Paper>
                    <Box m={0} padding={2}>
                        <Paper elevation={0}>
                            <TextField
                                variant="outlined"
                                label={isNotImage ? "Name Datei" : "Name Bild"}
                                name="name"
                                value={image.document.name || " "}
                                onChange={handleTextChange}
                                fullWidth
                                disabled={isSorting}
                            />
                            <TextField
                                variant="outlined"
                                label="Titel"
                                name="title"
                                value={image.document.title || " "}
                                onChange={handleTextChange}
                                fullWidth
                                disabled={isSorting}
                            />
                            <TextField
                                variant="outlined"
                                label="Copyright *"
                                name="copyright"
                                value={image.document.copyright || " "}
                                onChange={handleTextChange}
                                fullWidth
                                disabled={isSorting}
                            />

                            <TextField
                                variant="outlined"
                                label="Beschreibung"
                                name="description"
                                value={image.document.description || " "}
                                onChange={handleTextChange}
                                fullWidth
                                multiline
                                disabled={isSorting}
                            />
                        </Paper>
                        {!isSorting && (
                            <IconButton
                                className="event_form-button"
                                onClick={() => {
                                    onDelete(type, index);
                                }}
                                title="Löschen"
                            >
                                <IconDelete />
                            </IconButton>
                        )}

                        {image.isChanged && image.id != null && (
                            <IconButton
                                className="event_form-button"
                                color="secondary"
                                title="Zurücksetzen"
                                onClick={() => {
                                    onReset(type, index, parseInt("" + image.id));
                                }}
                            >
                                <IconReplay />
                            </IconButton>
                        )}
                    </Box>
                </FormControl>
            </Card>
        </Grid>
    );
};
export default ImageGalleryCard;
